import type { SimpleIslandMode } from './types';

export function isPeekingIslandMode(mode: SimpleIslandMode) {
  return mode === 'peeking';
}
